import React, { useCallback } from 'react'
import { useCompany } from '../../../../api/company/hooks'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { Step3AresProps } from '../types'

const useStep3Ares = (activationObject?: ActivationObject): Step3AresProps => {
    const [icoSearch, setIcoSearch] = React.useState<string>(activationObject?.ico || '')
    const handleSetIcoSearch = useCallback((val: string) => {
        setIcoSearch(val)
    }, [])

    const { data: aresData, isLoading, isFetched } = useCompany(icoSearch)

    React.useEffect(() => {
        setIcoSearch(activationObject?.ico || '')
    }, [activationObject?.ico])

    return {
        companyData: aresData,
        icoSearch,
        handleSetIcoSearch,
        isLoading,
        notFound: icoSearch !== aresData?.ic && isFetched && !isLoading,
    }
}

export default useStep3Ares
